import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined';
import EmailIcon from '@mui/icons-material/Email';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CachedIcon from '@mui/icons-material/Cached';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AccessTimeFilledOutlinedIcon from '@mui/icons-material/AccessTimeFilledOutlined';
import List from '../table/Table';
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { userDetails } from '../../redux/slices/userSlice';
import { listOrders } from '../../redux/slices/orderSlice';
const ProfileDetails = () => {
 
    const { error, loading, user } = useSelector((state) => state.singleUser);
  const {
    orders,
    loading: ordersLoading,
    error: ordersError,
  } = useSelector((state) => state.listOrders);

  const dispatch = useDispatch();
  const { userId } = useParams();
  useEffect(() => {
    dispatch(userDetails(userId));
    dispatch(listOrders());
  }, [dispatch, userId]);

  const allOrders = orders?.map((order) => {
    return order;
  });
  const myOrder = allOrders?.filter((order) => {
    return order?.user?.email === user?.email;
  });
    return(
        <div className='flex justify-center flex-col'>
            <div className='flex flex-row justify-between'>
                <div className='flex flex-row  border border-orange-500 my-6 h-24 py-4 w-56 lg:w-[13vw] px-4 rounded-xl'>
                    <div className='bg-orange-500 w-[3.5vw] text-center pt-4 rounded-xl'>
                        <PersonOutlinedIcon className='' style={{
                                        color: 'white',
                                    }}/>
                    </div>
                    <div className='ml-4 '>
                        <h1 className='text-xl text-slate-600 font-medium'>546</h1>
                        <p className='font-thin text-slate-400'>Bought</p>
                    </div>
                </div>
                <div className='flex flex-row ml-8 border border-orange-500 my-6 h-24 py-4 w-56 lg:w-[13vw] px-4 rounded-xl'>
                    <div className='bg-blue-500 w-16 text-center pt-4 rounded-xl'>
                        <ShoppingCartOutlinedIcon className='' style={{
                                        color: 'white',
                                    }}/>
                    </div>
                    <div className='ml-4 '>
                        <h1 className='text-xl text-slate-600 font-medium'>1546</h1>
                        <p className='font-thin text-slate-400'>Wish List</p>
                    </div>
                </div>
                <div className='flex flex-row ml-8 border border-orange-500 my-6 h-24 py-4 w-56 lg:w-[13vw] px-4 rounded-xl'>
                    <div className='bg-slate-500 w-16 text-center pt-4 rounded-xl'>
                        <LocalAtmOutlinedIcon className='' style={{
                                        color: 'white',
                                    }}/>
                    </div>
                    <div className='ml-4 '>
                        <h1 className='text-xl text-slate-600 font-medium'>06</h1>
                        <p className='font-thin text-slate-400'>Voucher</p>
                    </div>
                </div>
               
            </div>

            <div className='flex flex-col border lg:h-[70vh] h-[50vh] w-[80vw] lg:w-[55vw] rounded-xl overflow-hidden '>
                <div className='flex flex-row justify-between align-center px-8 mt-6'>
                    <h1 className='text-2xl text-slate-600 font-medium'>Latest Updates</h1>
                    <div>
                        <CachedIcon />
                        <MoreVertIcon />
                    </div>
                </div>
                <div className='border mt-6'></div>
                <div>
                    <h1 className="title ml-4">Transactions: {myOrder?.length}</h1>
            <List myOrder={myOrder} />
                </div>
            </div>
        </div>
    )
}
export default ProfileDetails